'use strict'
module.exports = Object.hasOwn || Function.prototype.bind.call(Function.prototype.call, Object.prototype.hasOwnProperty)
